import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IUser } from 'src/app/shared/interfaces/user.interface';
import { CustomProductCardEnt } from 'src/app/shared/interfaces/custom-product-card-ent';
import { SharedService } from 'src/app/shared/services/shared.service';
import { WishList } from 'src/app/utils/functions/wishList';

@Component({
  selector: 'app-custom-product-card',
  templateUrl: './custom-product-card.component.html',
  styleUrls: ['./custom-product-card.component.css']
})
export class CustomProductCardComponent implements OnInit {

  isLoved?: boolean = false;
  user?: IUser;

  @Input() product: CustomProductCardEnt = new CustomProductCardEnt();
  @Input() showFavorites?: boolean  = true;

  constructor(
    private router: Router,
    private wishList: WishList,
    private readonly _sharedService : SharedService
    ){
  }
  ngOnInit(): void {
    this.user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')!) : undefined;
    this.isLoved = this.product.isFavorite;
  }

  detail() {
    this.router.navigate(['/product-catalog/detail', this.product.id, this.product.category]);
  }

  async loved(product: any){
    this.isLoved = !this.isLoved;
    if(!this.isLoved){
      this._sharedService.deleteFavorite(product.id).subscribe({
        next: (response)=> {},
        error: (e)=> {
          console.debug(e);
          throw e;
        }
      });
    } else {
      this._sharedService.addFavorite(product.id).subscribe({
        next: (response) => {},
        error: (e)=> {
          console.debug(e);
          throw e;
        }
      });
    }
  }

  getClassList() {

    if(this.isLoved){
      return {
        'pi pi-heart-fill': this.isLoved
      };
    }else{
      return {
        'pi pi-heart': !this.isLoved
      };
    }

  }

  addProductCar: boolean = false;

  addCar(){

    this.wishList.addItemWishList(this.product, 1);
    this.addProductCar = true;

  }

  handleEvent(eventData: boolean) {
    this.addProductCar = eventData;
  }
}
